import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';

const classes = {
	leftControl: 'js-m-scrollable-jobfeed__left-control',
	rightControl: 'js-m-scrollable-jobfeed__right-control',
	leftControlNew: 'js-m-scrollable-jobfeed__left-new-control',
	rightControlNew: 'js-m-scrollable-jobfeed__right-new-control',
	hiddenControl: 'state-m-scrollable-jobfeed__slider-arrow-hidden',
	hiddenControlNew: 'state-m-scrollable-jobfeed__slider-new-arrow-hidden',
	scrollWrapper: "js-m-scrollable-jobfeed__scroll-wrapper",
	scrollWrapperNew: "js-m-scrollable-jobfeed__scroll-new-wrapper",
	headWrapper: "js-m-scrollable-jobfeed__head",
	headWrapperNew: "js-m-scrollable-jobfeed-new__head",
	contentWrapper: "js-m-scrollable-jobfeed__content",
	contentWrapperNew: "js-m-scrollable-jobfeed-new__content",
	contentScrollWrapper: "js-m-scrollable-jobfeed__content-scroll",
	contentScrollWrapperNew: "js-m-scrollable-jobfeed__content-new-scroll",
	listWrapper: "js-m-scrollable-jobfeed__list",
	listWrapperNew: "js-m-scrollable-jobfeed-new__list",
	jobfeedItem: "js-m-scrollable-jobfeed__list-item",
	videoWrapper: "js-m-scrollable-jobfeed-item__video-area",
	largejobfeed: 'm-scrollable-jobfeed__list-item--large',
	timelineItem: "js-m-scrollable-jobfeed__timeline-item",
	timelineItemBar: "m-scrollable-jobfeed-item__time-bar",
	disabledSilder: 'm-scrollable-jobfeed--disabled-silder',
	moduleList: 'm-scrollable-jobfeedList',
	moduleNew: 'm-scrollable-jobfeedNew',
	tabsButton: 'js-m-info-list__tab'
};

@createModule('ScrollableJobfeed')
/**
 * scrollable-jobfeed module implementation.
 */

export class ScrollableJobfeed extends TerrificSpec {
	$ctx: JQuery;
	$leftControl: JQuery;
	$rightControl: JQuery;
	$leftControlNew: JQuery;
	$rightControlNew: JQuery;
	$scrollWrapper: JQuery;
	$scrollWrapperNew: JQuery;
	$headWrapper: JQuery;
	$headWrapperNew: JQuery;
	$contentWrapper: JQuery;
	$contentWrapperNew: JQuery;
	$contentScrollWrapper: JQuery;
	$contentScrollWrapperNew: JQuery;
	$listWrapper: JQuery;
	$listWrapperNew: JQuery;
	$jobfeedItem: JQuery;
	$videoWrapper: JQuery;
	$timelineItem: JQuery;
	$moduleList: JQuery;
	$moduleNew: JQuery;
	$tabsButton: JQuery;

	start(resolve: Function) {
		this.initVars();

		setTimeout(() => {
			this.initNavigationArrows();
			this.initScroll();
			this.onScroll();
		}, 100);


		onBreakpointChange(() => {
			this.initNavigationArrows();
			this.onScroll();
		});
		$(window).resize(() => {
			this.initScroll();
		});

		resolve();
	}

	initVars() {
		this.$ctx = $(this._ctx);
		this.$leftControl = $(`.${classes.leftControl}`, this.$ctx);
		this.$rightControl = $(`.${classes.rightControl}`, this.$ctx);
		this.$leftControlNew = $(`.${classes.leftControlNew}`, this.$ctx);
		this.$rightControlNew = $(`.${classes.rightControlNew}`, this.$ctx);
		this.$scrollWrapper = $(`.${classes.scrollWrapper}`, this.$ctx);
		this.$scrollWrapperNew = $(`.${classes.scrollWrapperNew}`, this.$ctx);
		this.$headWrapper = $(`.${classes.headWrapper}`, this.$ctx);
		this.$headWrapperNew = $(`.${classes.headWrapperNew}`, this.$ctx);
		this.$contentWrapper = $(`.${classes.contentWrapper}`, this.$ctx);
		this.$contentWrapperNew = $(`.${classes.contentWrapperNew}`, this.$ctx);
		this.$contentScrollWrapper = $(`.${classes.contentScrollWrapper}`, this.$ctx);
		this.$contentScrollWrapperNew = $(`.${classes.contentScrollWrapper}`, this.$ctx);
		this.$listWrapper = $(`.${classes.listWrapper}`, this.$ctx);
		this.$listWrapperNew = $(`.${classes.listWrapperNew}`, this.$ctx);
		this.$jobfeedItem = $(`.${classes.jobfeedItem}`, this.$ctx);
		this.$videoWrapper = $(`.${classes.videoWrapper}`, this.$ctx);
		this.$timelineItem = $(`.${classes.timelineItem}`, this.$ctx);
		this.$moduleList = $(`.${classes.moduleList}`, this.$ctx);
		this.$moduleNew = $(`.${classes.moduleNew}`, this.$ctx);
		this.$tabsButton = $(`.${classes.tabsButton}`, this.$ctx);
	}

	initNavigationArrows() {
		this.$leftControl.on('click', () => {
			this.onLeftControlClick();
		});

		this.$rightControl.on('click', () => {
			this.onRightControlClick()
		});

		this.$leftControlNew.on('click', () => {
			this.onLeftControlNewClick();
		});

		this.$rightControlNew.on('click', () => {
			this.onRightControlNewClick()
		});
		
		this.$rightControlNew.on('click', () => {
			this.onRightControlNewClick()
		});
		this.$tabsButton.on('click', () => {
			this.initScroll()
		});
	}

	initScroll() {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small') {
			if (this.$listWrapper.width() < this.$contentScrollWrapper.width()) {
				this.$moduleList.addClass(classes.disabledSilder);
			} else {
				this.$moduleList.removeClass(classes.disabledSilder);
			}
			if (this.$listWrapperNew.width() < this.$contentScrollWrapperNew.width()) {
				this.$moduleNew.addClass(classes.disabledSilder);
			} else {
				this.$moduleNew.removeClass(classes.disabledSilder);
			}
		} else {
			if (this.$headWrapper.width() + this.$listWrapper.width() < this.$scrollWrapper.width() + 1) {
				this.$moduleList.addClass(classes.disabledSilder);
			} else {
				this.$moduleList.removeClass(classes.disabledSilder);
			}
			if (this.$headWrapperNew.width() + this.$listWrapperNew.width() < this.$scrollWrapperNew.width() + 1) {
				this.$moduleNew.addClass(classes.disabledSilder);
			} else {
				this.$moduleNew.removeClass(classes.disabledSilder);
			}
		}
	}

	/**
	 * method click left arrow
	 */
	onLeftControlClick() {
		this.$rightControl.parent().removeClass(classes.hiddenControl)
		this.jobfeedScrollLeft();
	}

	jobfeedScrollLeft() {
		var currentScrollLeft = this.$scrollWrapper.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small') {
			this.$contentScrollWrapper.animate(
				{
					scrollLeft: contentCurrentScrollLeft - mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft <= mobileItemWidth) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
		} else {
			this.$scrollWrapper.animate(
				{
					scrollLeft: currentScrollLeft - 250,
				},
				150
			);
			if (currentScrollLeft <= 250) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
		}
	}


	jobfeedScrollNewLeft() {
		var currentScrollLeft = this.$scrollWrapperNew.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapperNew.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small') {
			this.$contentScrollWrapperNew.animate(
				{
					scrollLeft: contentCurrentScrollLeft - mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft <= mobileItemWidth) {
				this.$leftControlNew.parent().addClass(classes.hiddenControlNew)
			}
		} else {
			this.$scrollWrapperNew.animate(
				{
					scrollLeft: currentScrollLeft - 250,
				},
				150
			);
			if (currentScrollLeft <= 250) {
				this.$leftControlNew.parent().addClass(classes.hiddenControlNew)
			}
		}
	}
	/**
	 * method click right arrow
	 */
	onRightControlClick() {
		this.$leftControl.parent().removeClass(classes.hiddenControl)
		this.jobfeedScrollRight();
	}

	onLeftControlNewClick() {
		this.$rightControlNew.parent().removeClass(classes.hiddenControlNew)
		this.jobfeedScrollNewLeft();
	}

	onRightControlNewClick() {
		this.$leftControlNew.parent().removeClass(classes.hiddenControlNew)
		this.jobfeedScrollNewRight();
	}

	jobfeedScrollRight() {
		var currentScrollLeft = this.$scrollWrapper.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		var maxScrollArea = this.$headWrapper.width() + this.$contentWrapper.width() - this.$scrollWrapper.width();
		var maxContentScrollArea = this.$listWrapper.width() - this.$contentScrollWrapper.width();
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small') {
			this.$contentScrollWrapper.animate(
				{
					scrollLeft: contentCurrentScrollLeft + mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft + mobileItemWidth > maxContentScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl);
			}
		} else {

			this.$scrollWrapper.animate(
				{
					scrollLeft: currentScrollLeft + 250,
				},
				150
			);
			if (currentScrollLeft + 250 > maxScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl)
			}
		}
	}

	jobfeedScrollNewRight() {
		var currentScrollLeft = this.$scrollWrapperNew.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapperNew.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		var maxScrollArea = this.$headWrapperNew.width() + this.$contentWrapperNew.width() - this.$scrollWrapperNew.width();
		var maxContentScrollArea = this.$listWrapperNew.width() - this.$contentScrollWrapperNew.width();
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small') {
			this.$contentScrollWrapperNew.animate(
				{
					scrollLeft: contentCurrentScrollLeft + mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft + mobileItemWidth > maxContentScrollArea - 1) {
				this.$rightControlNew.parent().addClass(classes.hiddenControlNew);
			}
		} else {

			this.$scrollWrapperNew.animate(
				{
					scrollLeft: currentScrollLeft + 250,
				},
				150
			);
			if (currentScrollLeft + 250 > maxScrollArea - 1) {
				this.$rightControlNew.parent().addClass(classes.hiddenControlNew)
			}
		}
	}

	onScroll() {
		const viewport = getCurrentBreakpoint() as string;
		this.$scrollWrapper.on('scroll', () => {
			console.log('scrolling');
			var currentScrollLeft = this.$scrollWrapper.scrollLeft();
			var maxScrollArea = this.$headWrapper.width() + this.$contentWrapper.width() - this.$scrollWrapper.width();
			if (currentScrollLeft > 0) {
				this.$leftControl.parent().removeClass(classes.hiddenControl)
			} else if (currentScrollLeft == 0) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
			if (currentScrollLeft > maxScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl)
			} else if (currentScrollLeft < maxScrollArea - 1) {
				this.$rightControl.parent().removeClass(classes.hiddenControl)
			}
		});
		this.$scrollWrapperNew.on('scroll', () => {
			console.log('scrolling');
			var currentScrollLeft = this.$scrollWrapperNew.scrollLeft();
			var maxScrollArea = this.$headWrapperNew.width() + this.$contentWrapperNew.width() - this.$scrollWrapperNew.width();
			if (currentScrollLeft > 0) {
				this.$leftControlNew.parent().removeClass(classes.hiddenControlNew)
			} else if (currentScrollLeft == 0) {
				this.$leftControlNew.parent().addClass(classes.hiddenControlNew)
			}
			if (currentScrollLeft > maxScrollArea - 1) {
				this.$rightControlNew.parent().addClass(classes.hiddenControlNew)
			} else if (currentScrollLeft < maxScrollArea - 1) {
				this.$rightControlNew.parent().removeClass(classes.hiddenControlNew)
			}
		});
	}

	stop() { }
}
